import { useState } from "react";
import { Star, StarFill } from "react-bootstrap-icons";
import "./StarRating.css";

export const STAR_VALUES = [1, 2, 3, 4, 5];

export const StarRating = ({ rating, onRate, readOnly = false, size = 20 }) => {
    const [hoverValue, setHoverValue] = useState(null);

    const displayValue = readOnly ? (rating ?? 0) : (hoverValue ?? rating ?? 0);

    const handleClick = (value) => {
        if (readOnly) return;
        if (value === rating) return;
        onRate(value);
    };

    return (
        <span
            className={`star-rating${readOnly ? " star-rating-readonly" : ""}`}
            aria-label="Rating"
        >
            {STAR_VALUES.map((value) => {
                const filled = value <= displayValue;
                const Icon = filled ? StarFill : Star;
                return (
                    <Icon
                        key={value}
                        size={size}
                        className="star-rating-star"
                        onClick={() => handleClick(value)}
                        onMouseEnter={() => !readOnly && setHoverValue(value)}
                        onMouseLeave={() => !readOnly && setHoverValue(null)}
                        aria-label={`${value} star${value > 1 ? "s" : ""}`}
                    />
                );
            })}
        </span>
    );
};
